import React from "react";
import { useInvitationLanguage } from "./InvitationLanguage";
import welcome from "../../assets/img/timeline-welcome.svg";
import rings from "../../assets/img/timeline-rings.svg";
import dinner from "../../assets/img/timeline-dinner.svg";
import celebration from "../../assets/img/timeline-celebration.svg";
import farewell from "../../assets/img/timeline-farewell.svg";
import disco from "../../assets/img/timeline-disco.svg";
import "./WeddingInvitationSchedule.css";

export const weddingTimelineEvents = [
  { time: "17:30", title: "Welcome & Photos", titleVi: "Đón khách & Chụp ảnh", graphic: welcome },
  { time: "19:00", title: "Wedding Ceremony", titleVi: "Lễ thành hôn", graphic: rings },
  { time: "19:30", title: "Wedding Dinner", titleVi: "Tiệc cưới", graphic: dinner },
  { time: "20:30", title: "Mini Games", titleVi: "Trò chơi", graphic: celebration },
  { time: "21:30", title: "Farewell & Thank You", titleVi: "Tiễn khách & Cảm ơn", graphic: farewell },
  { time: "22:30", title: "After Party", titleVi: "Tiệc sau lễ", graphic: disco },
];

export const dressCodeColors = [
  { name: "Blush beige", nameVi: "Be hồng", color: "#dfc6b9" },
  { name: "Cream yellow", nameVi: "Vàng kem", color: "#ffe8b0" },
  { name: "Black", nameVi: "Đen", color: "#000000" },
  { name: "Muted blue", nameVi: "Xanh dương trầm", color: "#3b608a" },
];

export default function WeddingInvitationSchedule() {
  const { t } = useInvitationLanguage();
  return (
    <>
      <section className="invitation-timeline" aria-labelledby="invitation-timeline-title">
        <h2 id="invitation-timeline-title">{t("Our Timeline", "Lịch trình")}</h2>
        <div className="invitation-timeline__journey">
          <svg className="invitation-timeline__thread" viewBox="0 0 100 1000" preserveAspectRatio="none" fill="none" aria-hidden="true">
            <path d="M35 0 C35 85 85 85 85 165 S15 250 15 335 S85 420 85 505 S15 590 15 675 S85 760 85 845 S35 930 35 1000" stroke="currentColor" strokeWidth="1.2" vectorEffect="non-scaling-stroke" />
          </svg>
          <ol className="invitation-timeline__events">
            {weddingTimelineEvents.map(({ time, title, titleVi, graphic }, index) => (
              <li key={time} style={{ gridColumn: index % 2 + 1, gridRow: `${index + 1} / span 2` }}>
                <img className="invitation-timeline__graphic" src={graphic} alt="" loading="lazy" />
                <time dateTime={`2027-01-17T${time}:00+07:00`}>{time}</time>
                <span className="invitation-timeline__event">{t(title, titleVi)}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section className="invitation-dress-code" aria-labelledby="invitation-dress-code-title">
        <h2 id="invitation-dress-code-title">{t("Dresscode", "Trang phục")}</h2>
        <p>{t("Your presence is what makes our day beautiful.", "Có bạn chung vui là điều làm ngày cưới thêm trọn vẹn.")}</p>
        <p>{t("We’d love for you to celebrate with us in the colors below — in something that feels like you, with a little room for dancing.", "Hãy chọn trang phục theo những gam màu dưới đây — thật đúng với bạn và thoải mái để cùng nhảy múa nhé.")}</p>
        <ul className="invitation-dress-code__palette" aria-label={t("Suggested outfit colors", "Màu trang phục gợi ý")}>
          {dressCodeColors.map(({ name, nameVi, color }) => (
            <li key={name}>
              <span className="invitation-dress-code__swatch" style={{ backgroundColor: color }} aria-hidden="true" />
              <span className="invitation-dress-code__color-name">{t(name, nameVi)}</span>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
